import { makeStyles } from "@material-ui/core";

export const useTrendingStyles = makeStyles((theme) => ({
	datetimePicker: {
		alignItems: "center",

		"& .MuiInputBase-root": {
			color: "black",
			backgroundColor: "white",
			borderRadius: theme.shape.borderRadius,
			width: "90%",
			minWidth: "90%",
			maxWidth: "90%",
		},

		"& .MuiInputBase-input": {
			fontSize: "13px !important",
			height: "15px !important",
			paddingRight: "3px",
			paddingLeft: "3px",
		},
		"& .MuiInput-underline:before": {
			borderBottomColor: "rgba(0, 0, 0, 0.42)",
		},
		padding: 0,
	},
	select: {
		"& .MuiInput-root": {
			width: "100%",
		},
		"& .MuiInputBase-root": {
			color: "black",
			backgroundColor: "white",
			borderRadius: theme.shape.borderRadius,
			minWidth: "100%",
		},
		"& .MuiInputBase-input": {
			fontSize: "14px !important",
			height: "15px !important",
		},
		"& .MuiInput-underline:before": {
			borderBottomColor: "rgba(0, 0, 0, 0.42)",
		},
		padding: 0,
	},

	labelOptions: {
		paddingLeft: "2rem",
		userSelect: "none",
		"& > label": {
			display: "flex",
			alignItems: "center",
			gap: "5px",
		},
		'& input[type="checkbox"]': {
			zoom: 1.5,
		},
	},
	isPublicCheckbox: {
		userSelect: "none",
		paddingLeft: "1rem",
		"& > label": {
			display: "flex",
			alignItems: "center",
			gap: "15px",
		},
		'& input[type="checkbox"]': {
			zoom: 1.5,
		},
	},

	navigatorButton: {
		"& .MuiSvgIcon-root": {
			cursor: "pointer !important",
			height: "24px",
			width: "24px",
			"& svg": {
				// Adjust the icon size as well
				fontSize: "1.5rem",
			},
		},
		color: "black",
	},

	iconContainer: {
		display: "flex",
		justifyContent: "flex-end",
		alignItems: "center",
		flex: 1,
	},
	optionContainer: {
		display: "flex",
		justifyContent: "flex-start",
		alignItems: "center",
		width: "100%",
	},
	optionLabel: {
		flexGrow: 1,
	},

	inputCustom: {
		color: "rgba(0, 0, 0, 0.87)",
		cursor: "text",
		fontSize: "0.7rem",
		boxSizing: "border-box",
		fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
		fontWeight: 400,
		lineHeight: 1.1876,
		letterSpacing: "0.00938em",
		"& .MuiOutlinedInput-input": {
			padding: "10px 10px",
		},
	},
}));
